import { render, staticRenderFns } from "./Giving.vue?vue&type=template&id=2aea7689&scoped=true"
import script from "./Giving.vue?vue&type=script&lang=js"
export * from "./Giving.vue?vue&type=script&lang=js"
import style0 from "./Giving.vue?vue&type=style&index=0&id=2aea7689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea7689",
  null
  
)

export default component.exports